<template>
<div class="filters">
  <v-container fluid>
    

<!-- <v-row>
    <v-col class="d-flex" cols="12" sm="6" md="4">
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="date"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="date"
            label="Selecionar intervalo de datas"
            prepend-icon="event"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="date" no-title scrollable range>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
          <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
        </v-date-picker>
      </v-menu>
    </v-col>
</v-row> -->

      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="3">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date"
                label="Selecionar intervalo de datas"
                prepend-icon="event"
                readonly
                v-on="on"
                class="input-datas"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date" no-title scrollable range>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
              <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>

        <v-col class="d-flex" cols="12" sm="3">
          <v-select
            :items="items"
            label="Produto"
            dense
          ></v-select>
        </v-col>

      <v-col class="d-flex" cols="12" sm="3">
        <v-select
          :items="items"
          label="Consultor"
          dense
        ></v-select>
      </v-col>

      <v-col class="d-flex" cols="12" sm="3">
        <v-select
          :items="items"
          label="Modo de Visualização"
          dense
        ></v-select>
      </v-col>
    </v-row>
  </v-container>
  </div>
</template>

<script>
  export default {
      name:'FiltersReport',
    data: () => ({
      items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
      date: ['2019-09-10', '2019-09-20'],
      menu: false,
      modal: false,
      menu2: false,
    }),
    computed: {
      dateRangeText () {
        return this.dates.join(' ~ ')
      },
    },
  }
</script>

<style scoped>
  .filters{
      margin: 20px 40px 0px 296px;
    }

    .input-datas{
      margin-top: -2px;
      font-size:14px;
    }
</style>